import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, unref as _unref, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d5ff12c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "active" }
const _hoisted_2 = { class: "active__actions mb--20" }
const _hoisted_3 = { class: "active__actions__filters allBlockWidth" }
const _hoisted_4 = { class: "mb--20" }
const _hoisted_5 = { class: "active__actions-sort only-mobile" }
const _hoisted_6 = { class: "none-Mobile items-in-line flex-start" }
const _hoisted_7 = {
  key: 0,
  class: "active__cards"
}
const _hoisted_8 = {
  key: 1,
  class: "active__cards"
}
const _hoisted_9 = {
  key: 2,
  class: "center"
}

import AnnouncementCard from '@/components/ProfileComponents/MyAnnouncements/AnnouncementCard/AnnouncementCard.vue';
import { computed, onMounted, Ref, ref, watch } from 'vue';
import { useDevelopersStore } from '@/store/modules/developers';
import { SmallOfferCardType } from '@/types/MainPageTypes';
import {
  CreateCategoryModalType,
  GetAnnouncementsDataType,
  OptionType,
  TypesMyAdsType,
} from '@/types';
import { CreateDeveloperModal } from '@/components/ProfileComponents';
import { useRoute, useRouter } from 'vue-router';
import { OpenSorting } from '@/components';
import AnnouncementsFilterInputs from '@/components/ProfileComponents/AnnounsmentsFilterInputs/AnnouncementsFilterInputs.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AnnouncementList',
  props: {
    type: {}
  },
  setup(__props: any) {

const props = __props;

const route = useRoute();
const router = useRouter();

const developerId: Ref<number | undefined> = ref(undefined);
const residentialComplexId: Ref<number | undefined> = ref(undefined);
const constructionLineId: Ref<number | undefined> = ref(undefined);

const filterHandler = async () => {
  await getAnnouncements({
    developerId: developerId.value,
    residentialComplexId: residentialComplexId.value,
    queueId: constructionLineId.value,
  });
};

const activeSort: Ref<number | undefined> = ref(undefined);
const sortOptions: OptionType[][] = [
  [
    { id: 1, name: 'По цене', key: 'price', icon: 'north' },
    { id: 2, name: 'По цене', key: 'price', icon: 'south' },
  ],
  [
    { id: 3, name: 'По дате', key: 'activeFrom', icon: 'north' },
    { id: 4, name: 'По дате', key: 'activeFrom', icon: 'south' },
  ],
  [
    { id: 5, name: 'По просмотрам', key: 'views', icon: 'north' },
    { id: 6, name: 'По просмотрам', key: 'views', icon: 'south' },
  ],
  [
    { id: 7, name: 'По избранным', key: 'favorites', icon: 'north' },
    { id: 8, name: 'По избранным', key: 'favorites', icon: 'south' },
  ],
];

const resultCards = computed((): SmallOfferCardType[] | undefined => {
  if (props.type === 'active') {
    return useDevelopersStore().orderList;
  } else if (props.type === 'drafts') {
    return useDevelopersStore().draftAdList;
  } else if (props.type === 'archive') {
    return useDevelopersStore().archiveAdList;
  }

  return [];
});

const preparedResultCards = computed((): SmallOfferCardType[] => {
  const getValue = (card: SmallOfferCardType, option: OptionType) => {
    const value = card[option.key as keyof SmallOfferCardType] as number | string;

    if ((option.id === 3 || option.id === 4) && value) {
      return new Date(value as string);
    }

    return value;
  };
  const sortCardsByField = (option: OptionType) => {
    if ((option.id as number) % 2 === 0) {
      return (a: SmallOfferCardType, b: SmallOfferCardType) =>
        getValue(a, option) < getValue(b, option) ? 1 : -1;
    } else {
      return (a: SmallOfferCardType, b: SmallOfferCardType) =>
        getValue(a, option) > getValue(b, option) ? 1 : -1;
    }
  };

  const option = sortOptions.flat().find(el => el.id === activeSort.value);

  if (resultCards.value && option) {
    const copedResultCards: SmallOfferCardType[] = [...resultCards.value];

    return copedResultCards.sort(sortCardsByField(option));
  }

  return resultCards.value ?? [];
});

const createCategoryModalData: Ref<CreateCategoryModalType> = ref({
  show: false,
  categoryTitle: undefined,
});
const showCreateCategoryModal = (event: { categoryTitle: string }) => {
  router.push({ hash: '#create' });
  createCategoryModalData.value = {
    show: true,
    categoryTitle: event.categoryTitle,
  };
};
const closeCreateCategoryModal = () => {
  createCategoryModalData.value = {
    show: false,
    categoryTitle: undefined,
  };
};

const newDraftAdId: Ref<number | undefined> = ref(undefined);
const createCategory = (event: { id: number; title: string }) => {
  newDraftAdId.value = event.id;
  router.push({ query: { menuItem: 'drafts' } });
};

const deleteCategory = async (id: number) => {
  useDevelopersStore().deleteAd(props.type, id);
};

const isLoading = ref(false);
const getAnnouncements = async (data?: GetAnnouncementsDataType) => {
  try {
    isLoading.value = true;

    if (props.type === 'active') {
      await useDevelopersStore().getOrderList(data);
    } else if (props.type === 'drafts') {
      await useDevelopersStore().getDrafts(data);
      if (newDraftAdId.value) {
        useDevelopersStore().updateIsNewAd(newDraftAdId.value);
        newDraftAdId.value = undefined;
      }
    } else if (props.type === 'archive') {
      await useDevelopersStore().getArchive(data);
    }

    activeSort.value = 4;
  } finally {
    isLoading.value = false;
  }
};

const hash = computed(() => {
  return route?.hash;
});

const checkIsCreate = () => {
  if (hash.value) {
    const isCreate = hash.value === '#create';

    if (isCreate) {
      showCreateCategoryModal({ categoryTitle: 'Объявление' });
    }
  }
};

onMounted(async () => {
  checkIsCreate();
  if (!resultCards.value) {
    await getAnnouncements();
  }
});
watch(
  () => hash.value,
  () => {
    checkIsCreate();
  },
);
watch(
  () => props.type,
  () => {
    developerId.value = undefined;
    residentialComplexId.value = undefined;
    constructionLineId.value = undefined;
    getAnnouncements();
  },
);

return (_ctx: any,_cache: any) => {
  const _component_base_select_input = _resolveComponent("base-select-input")!
  const _component_base_skeleton_loader = _resolveComponent("base-skeleton-loader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(AnnouncementsFilterInputs, {
          constructionLineId: constructionLineId.value,
          "onUpdate:constructionLineId": _cache[0] || (_cache[0] = ($event: any) => ((constructionLineId).value = $event)),
          developerId: developerId.value,
          "onUpdate:developerId": _cache[1] || (_cache[1] = ($event: any) => ((developerId).value = $event)),
          residentialComplexId: residentialComplexId.value,
          "onUpdate:residentialComplexId": _cache[2] || (_cache[2] = ($event: any) => ((residentialComplexId).value = $event)),
          onUpdateValues: _cache[3] || (_cache[3] = ($event: any) => (filterHandler()))
        }, null, 8, ["constructionLineId", "developerId", "residentialComplexId"])
      ]),
      (_ctx.type === 'active')
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "gradient-color",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (showCreateCategoryModal({ categoryTitle: 'Объявление' })))
          }, " Создать объявление "))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_base_select_input, {
          loading: isLoading.value,
          modelValue: activeSort.value,
          options: sortOptions.flat(),
          label: "Сортировать по",
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (activeSort.value = $event))
        }, null, 8, ["loading", "modelValue", "options"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_unref(OpenSorting), {
          modelValue: activeSort.value,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((activeSort).value = $event)),
          "sort-options": sortOptions
        }, null, 8, ["modelValue"])
      ])
    ]),
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (i) => {
            return _createVNode(_component_base_skeleton_loader, {
              key: i,
              styles: { height: '126px', width: '100%' },
              class: "mb--5",
              type: "mediumText"
            })
          }), 64))
        ]))
      : (preparedResultCards.value && preparedResultCards.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(preparedResultCards.value, (card) => {
              return (_openBlock(), _createElementBlock("div", {
                key: card.id
              }, [
                _createVNode(AnnouncementCard, {
                  card: card,
                  type: _ctx.type,
                  onDeleteCategory: deleteCategory
                }, null, 8, ["card", "type"])
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, "Объявлений нет")),
    _createVNode(_unref(CreateDeveloperModal), {
      "create-category-modal-data": createCategoryModalData.value,
      isOfferCard: "",
      onClose: closeCreateCategoryModal,
      onCreateCategory: _cache[7] || (_cache[7] = ($event: any) => (createCategory($event)))
    }, null, 8, ["create-category-modal-data"])
  ]))
}
}

})